import { Plus, X } from "lucide-react";
import { Input } from "../ui/input";
import { Btn, F } from "./ui";

// rebuild variants for sizes x colors, keeping existing stock/sku
export const buildVariants = (sizes, colors, old = [], baseSku = "") => {
  const s = sizes.length ? sizes : [""];
  const c = colors.length ? colors.map((x) => x.name_ar) : [""];
  const out = [];
  s.forEach((size) => c.forEach((color, ci) => {
    const prev = old.find((v) => v.size === size && v.color === color);
    out.push(prev || { size, color, stock: 0, sku: [baseSku, size, ci].filter((x) => x !== "").join("-") });
  }));
  return out;
};

export const VariantsEditor = ({ form, set }) => {
  const setSizes = (txt) => {
    const sizes = txt.split(/[,،]/).map((x) => x.trim()).filter(Boolean);
    set({ sizes, sizesText: txt, variants: buildVariants(sizes, form.colors, form.variants, form.sku) });
  };
  const setColors = (colors) => set({ colors, variants: buildVariants(form.sizes, colors.filter((c) => c.name_ar), form.variants, form.sku) });
  const setVar = (i, patch) => set({ variants: form.variants.map((v, k) => (k === i ? { ...v, ...patch } : v)) });

  return (
    <div className="space-y-5">
      <F label="المقاسات (افصلي بفاصلة) مثال: 52, 54, 56" value={form.sizesText ?? form.sizes.join(", ")} onChange={setSizes} testid="product-sizes-input" dir="ltr" />
      <div>
        <p className="mb-2 text-xs text-gray-600">الألوان</p>
        <div className="space-y-2">
          {form.colors.map((c, i) => (
            <div key={i} className="flex items-center gap-2">
              <input type="color" value={c.hex} onChange={(e) => setColors(form.colors.map((x, k) => (k === i ? { ...x, hex: e.target.value } : x)))} className="h-9 w-10 cursor-pointer rounded border" />
              <Input data-testid={`color-name-ar-${i}`} placeholder="الاسم بالعربية" value={c.name_ar} onChange={(e) => setColors(form.colors.map((x, k) => (k === i ? { ...x, name_ar: e.target.value } : x)))} className="bg-white" />
              <Input placeholder="English" dir="ltr" value={c.name_en} onChange={(e) => setColors(form.colors.map((x, k) => (k === i ? { ...x, name_en: e.target.value } : x)))} className="bg-white" />
              <button type="button" onClick={() => setColors(form.colors.filter((_, k) => k !== i))} className="p-2 text-red-600"><X size={15} /></button>
            </div>
          ))}
        </div>
        <Btn type="button" variant="light" className="mt-2" data-testid="add-color-button" onClick={() => setColors([...form.colors, { name_ar: "", name_en: "", hex: "#0A0A0A" }])}><Plus size={14} />إضافة لون</Btn>
      </div>
      <div className="overflow-x-auto rounded border border-gray-200">
        <table className="w-full min-w-[480px] text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500"><tr className="text-right"><th className="p-2">المقاس</th><th>اللون</th><th>الكمية</th><th>SKU الخيار</th></tr></thead>
          <tbody>
            {form.variants.map((v, i) => (
              <tr key={`${v.size}-${v.color}`} className="border-t border-gray-100">
                <td className="p-2">{v.size || "—"}</td>
                <td>{v.color || "—"}</td>
                <td className="py-1"><Input data-testid={`variant-stock-${i}`} type="number" min="0" value={v.stock} onChange={(e) => setVar(i, { stock: Math.max(0, parseInt(e.target.value || "0", 10)) })} className="h-8 w-24 bg-white" /></td>
                <td className="py-1 pl-2"><Input dir="ltr" value={v.sku} onChange={(e) => setVar(i, { sku: e.target.value })} className="h-8 bg-white font-mono text-xs" /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
